// F-AA: title of a navigation link ({id, titleTc, titleEn, titleSc}) in the
// visitor's language, falling back to Traditional Chinese.
export function linkTitle(link, language) {
  if (!link) return "";
  if (language === "en" && link.titleEn) return link.titleEn;
  if (language === "sc" && link.titleSc) return link.titleSc;
  return link.titleTc;
}
